import { reactive } from 'vue'

enum DeviceType {
  PC,
  MOBILE
}
const MOBILE_MEDIA_WIDTH = 750
const NAV_HAMBURGER_WIDTH = 1000
interface Device {
  type: DeviceType
  windowWidth: number
  mobileMediaWidth: number
}

function deviceType(): DeviceType {
  if (window.innerWidth <= MOBILE_MEDIA_WIDTH) {
    return DeviceType.MOBILE
  } else {
    return DeviceType.PC
  }
}

function navDeviceType(): DeviceType {
  if (window.innerWidth <= NAV_HAMBURGER_WIDTH) {
    return DeviceType.MOBILE
  } else {
    return DeviceType.PC
  }
}

const device = reactive<Device>({
  type: deviceType(),
  windowWidth: window.innerWidth,
  mobileMediaWidth: MOBILE_MEDIA_WIDTH
})

const navDevice = reactive<Device>({
  type: navDeviceType(),
  windowWidth: window.innerWidth,
  mobileMediaWidth: NAV_HAMBURGER_WIDTH
})

function handleResize() {
  const type = deviceType()
  if (type != device.type) {
    device.type = type
  }
  const navType = navDeviceType()
  if (navType != navDevice.type) {
    navDevice.type = navType
  }
}

window.addEventListener('resize', handleResize)

function useDevice(): Device {
  return device
}

function useNavDevice(): Device {
  return navDevice
}

export { useDevice, useNavDevice, DeviceType }
